import { useState, useEffect, BaseSyntheticEvent } from "react";
import { IoHelpCircleOutline } from "react-icons/io5";
import HelpModal from "./HelpModal";
import "./styles.css";
import TooltipConfig from "../Tooltip";

const Help = () => {
  const [showModal, setShowModal] = useState(false);

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  const handleModal = (handle: boolean) => {
    setShowModal(handle);
  };

  useEffect(() => {
    if (!window.localStorage.getItem("firstEntry")) {
      setShowModal(true);
    }
  }, []);

  return (
    <TooltipConfig
      content={["Ajuda"]}
      children={
        <>
          <IoHelpCircleOutline
            onMouseOver={MouseOver}
            size={30}
            onClick={() => setShowModal(true)}
          />
          <HelpModal show={showModal} changeModal={handleModal} />
        </>
      }
      placement={"bottom"}
      style={true}
    />
  );
};

export default Help;
